import React, { Component } from "react";
import {
  Modal,
  ModalBody,
  Button,
  Row,
  Col,
  Form,
  Spinner,
  Label,
  Input,
} from "reactstrap";
import CustomToggler from "../components/CustomToggler";
import { createMemoir } from "../redux/actions/memoir.action";
import { Link,withRouter } from "react-router-dom";
// import { Redirect } from 'react-router';
import moment from "moment";
import {
  Birthday,
  Coorperate,
  Event,
  Myself,
  Object as Img_Object,
  Other,
  Pet,
  SomeoneElse,
  WeddingDate,
} from "../assets";
import { connect } from "react-redux";
import AddMedia from "../components/Modals/AddMedia";
import {
  displayImageUpdate,
  coverImageUpdate,
  getSingleMemoir,
  getSingleMedia,
  changeMemoirViewStatus,
} from "../redux/actions/memoir.action";
import {
  fetchByEmail,
  updateMemoirCollab,
} from "../redux/actions/collaboratives.action";
import MainHeader from "../components/MainHeader";
import { customAlert } from "../redux/actions/alertActions";
import MemoirMedia from "../components/MemoirMedia";
import Cropper from "react-easy-crop";
import getCroppedImg from "../components/GetCroppedImage";

class Timeline extends Component {
  
  state = {
    modals: {
      categories: false,
      createTimeline: false,
      addMedia: false,
      collabModal: false,
    },
    memoirData: {
      title: "",
      first_name: "",
      last_name: "",
      introduction: "",
      relationship: "",
      date_of_birth: "",
      date_of_death: "",
      home_town: "",
      isMemoirPublic: false,
      isHomeTownPublic: false,
      isDOBPublic: false,
      isHideFromSearchEngines: false,
      isIntroductionVisible: false,
    },
    categories: [
      { name: "Myself", image: Myself },
      { name: "Someone else", image: SomeoneElse },
      { name: "Pet", image: Pet },
      { name: "Birthday", image: Birthday },
      { name: "Anniversary", image: WeddingDate },
      { name: "Event", image: Event },
      { name: "Coorperate", image: Coorperate },
      { name: "Object", image: Img_Object },
      { name: "Other", image: Other },
    ],
    searchMedia: "",
    selectedCategory: "",
    profileType: "person",
    memoirId: window.location.pathname.split("/")[2],
    displayImage: "",
    coverImage: "",
    emailSearch: "",
    role: "",
    croppedAreaPixels: "",
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 4 / 3,
  };
 
  handleMemoirFieldChange = (name, value) => {
    let { memoirData } = this.state;
    memoirData[name] = value;
    this.setState({ memoirData });
  };
  resetMemoirState = () => {
    let obj = {};
    if (this.state.profileType == "person")
      obj = {
        title: "",
        first_name: "",
        last_name: "",
        introduction: "",
        relationship: "",
        date_of_birth: "",
        date_of_death: "",
        home_town: "",
        isMemoirPublic: false,
        isHomeTownPublic: false,
        isDOBPublic: false,
        isHideFromSearchEngines: false,
        isIntroductionVisible: false,
      };
    else
      obj = {
        else_category: "pet",
        introduction: "",
        start_date_dd: "",
        start_date_mm: "",
        start_date_yyyy: "",
        end_date_dd: "",
        end_date_mm: "",
        end_date_yyyy: "",
        location: "",
        isMemoirPublic: false,
        isHomeTownPublic: false,
        isDOBPublic: false,
        isHideFromSearchEngines: false,
        isIntroductionVisible: false,
      };
    this.setState({ memoirData: obj });
  };

  componentDidMount() {
    let prevState = this.props.history.location.state;
    if (prevState != null) {
      if (prevState["createMemoir"]) {
        let { modals } = JSON.parse(JSON.stringify(this.state));
        modals["categories"] = true;
        this.setState({
          modals,
        });
      }
    }
    if (this.state.memoirId != "") {
      this.props.getSingleMemoir(this.state.memoirId);
      this.props.getSingleMedia(this.state.memoirId);
    }
  }
  toggleModal = (name) => {
    let { modals } = JSON.parse(JSON.stringify(this.state));
    for (let modal of Object.keys(modals)) {
      if (modal != name) modals[modal] = false;
    }
    modals[name] = !modals[name];
    this.setState({
      ...this.state,
      modals,
    });
  };

  getRole = (memId, uid) => {
    if (this.props.memoirs.length > 0) {
      let memoirData = this.props.memoirs.find((mem) => mem.id == memId);
      let roleCheck = memoirData.collaborators.find(
        (collab) => collab.id == uid
      );
      if (roleCheck) {
        return roleCheck.role;
      } else {
        return "owner";
      }
    } else {
      return "owner";
    }
  };
  getMemoirDetails = (id) => {
    if (id != undefined) {
      let obj =
        this.props.memoirs.length > 0 &&
        this.props.memoirs.find((memoir) => memoir.id == id);
      if (obj != null) {
        return obj;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  onCropChange = (crop) => {
    this.setState({ crop });
  };

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    console.log(croppedArea, croppedAreaPixels);
    this.setState({ croppedAreaPixels: croppedAreaPixels });
  };

  onZoomChange = (zoom) => {
    this.setState({ zoom });
  };
  saveImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        this.state.displayImage,
        this.state.croppedAreaPixels
      );
      let obj = {
        display_image: croppedImage,
      };

      this.props.displayImageUpdate(
        obj,
        this.state.memoirId,
        this.props.authUser.id,
        () => {
          this.setState({
            displayImage: "",
          });
        }
      );
    } catch (e) {
      console.error(e);
    }
  };
  saveCropImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        this.state.coverImage,
        this.state.croppedAreaPixels
      );
      let obj = {
        cover_image: croppedImage,
      };

      this.props.coverImageUpdate(
        obj,
        this.state.memoirId,
        this.props.authUser.id,
        () => {
          this.setState({
            coverImage: "",
          });
        }
      );
    } catch (e) {
      console.error(e);
    }
  };
 
  // handleClick = () => {
  //   console.log(this.state.memoirData.isMemoirPublic,'this.state.memoirData.isMemoirPublic')
  //   this.props.history.push(`/main/timeline/${this.state.memoirId}`,{state: this.state.memoirData.isMemoirPublic});
  // };
  render() {
    return (
      <>
        <AddMedia
          isOpen={this.state.modals}
          toggleModal={this.toggleModal}
          id={this.state.memoirId}
        />
        <div className="container-fluid pt-3 mb-2">
          <MainHeader heading={"Memoir"} />
          <hr />
          <div className="mt-5">
            <div className="memoir">
              <div
                className="avatar-update-container"
                style={{
                  backgroundImage: `url(${
                    this.props.singleMemoir &&
                    this.props.singleMemoir.cover_image
                  })`,
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  backgroundSize: "cover",
                }}
              >
                <label
                  for="file"
                  className="avatar-update"
                  style={{
                    backgroundImage: `url(${
                      this.props.singleMemoir &&
                      this.props.singleMemoir.display_image
                    })`,
                    backgroundSize: "cover",
                  }}
                >
                  <input
                    id="file"
                    type="file"
                    accept="image/*"
                    onChange={async (e) => {
                      await this.setState({
                        displayImage: URL.createObjectURL(e.target.files[0]),
                      });
                    }}
                  ></input>

                  <svg
                    width="55"
                    height="50"
                    viewBox="0 0 55 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M50.2174 11.9048H42.637L38.2609 7.14286H23.913V11.9048H36.1565L40.5326 16.6667H50.2174V45.2381H11.9565V23.8095H7.17391V45.2381C7.17391 47.8571 9.32609 50 11.9565 50H50.2174C52.8478 50 55 47.8571 55 45.2381V16.6667C55 14.0476 52.8478 11.9048 50.2174 11.9048ZM19.1304 30.9524C19.1304 37.5238 24.487 42.8571 31.087 42.8571C37.687 42.8571 43.0435 37.5238 43.0435 30.9524C43.0435 24.381 37.687 19.0476 31.087 19.0476C24.487 19.0476 19.1304 24.381 19.1304 30.9524ZM31.087 23.8095C35.0326 23.8095 38.2609 27.0238 38.2609 30.9524C38.2609 34.881 35.0326 38.0952 31.087 38.0952C27.1413 38.0952 23.913 34.881 23.913 30.9524C23.913 27.0238 27.1413 23.8095 31.087 23.8095ZM11.9565 11.9048H19.1304V7.14286H11.9565V0H7.17391V7.14286H0V11.9048H7.17391V19.0476H11.9565V11.9048Z"
                      fill="black"
                      fill-opacity="0.25"
                    />
                  </svg>
                </label>

                <div className="qr-code text-center">
                  <Link
                    to={{
                      pathname: "/dashboard/qrcode",
                      state: {
                        selectedMemoir: this.state.memoirId,
                      },
                    }}
                  >
                    <div>
                      <span className="d-block">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 11.5556H11.5556V0H0V11.5556ZM2.88889 2.88889H8.66667V8.66667H2.88889V2.88889Z"
                            fill="black"
                          />
                          <path
                            d="M0 26H11.5556V14.4445H0V26ZM2.88889 17.3333H8.66667V23.1111H2.88889V17.3333Z"
                            fill="black"
                          />
                          <path
                            d="M14.4445 0V11.5556H26V0H14.4445ZM23.1111 8.66667H17.3333V2.88889H23.1111V8.66667Z"
                            fill="black"
                          />
                          <path
                            d="M26 23.1111H23.1111V26H26V23.1111Z"
                            fill="black"
                          />
                          <path
                            d="M17.3333 14.4445H14.4445V17.3333H17.3333V14.4445Z"
                            fill="black"
                          />
                          <path
                            d="M20.2223 17.3333H17.3334V20.2222H20.2223V17.3333Z"
                            fill="black"
                          />
                          <path
                            d="M17.3333 20.2222H14.4445V23.1111H17.3333V20.2222Z"
                            fill="black"
                          />
                          <path
                            d="M20.2223 23.1111H17.3334V26H20.2223V23.1111Z"
                            fill="black"
                          />
                          <path
                            d="M23.1111 20.2222H20.2222V23.1111H23.1111V20.2222Z"
                            fill="black"
                          />
                          <path
                            d="M23.1111 14.4445H20.2222V17.3333H23.1111V14.4445Z"
                            fill="black"
                          />
                          <path
                            d="M26 17.3333H23.1111V20.2222H26V17.3333Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      <span
                        className="mt-2 d-block text-uppercase"
                        style={{ fontSize: 14 }}
                      >
                        Generate
                        <br />
                        QR Code
                      </span>
                    </div>
                  </Link>
                </div>

                <label className="edit-icon-avatar">
                  <i class="fas fa-edit fa-3x"></i>{" "}
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={async (e) => {
                      await this.setState({
                        coverImage: URL.createObjectURL(e.target.files[0]),
                      });
                    }}
                  />
                </label>
              </div>
              <div className="text-center pt-3">
                <h3 className="font-weight-bold">
                  {this.props.singleMemoir &&
                    this.props.singleMemoir.first_name}{" "}
                  {this.props.singleMemoir && this.props.singleMemoir.last_name}
                </h3>
                <div
                  className={`align-items-center mt-1 justify-content-center ${
                    this.props.singleMemoir &&
                    this.props.singleMemoir.category == "Myself"
                      ? "d-flex"
                      : "d-none"
                  }`}
                >
                  <h5 className="m-0 font-weight-bold">
                    {this.props.singleMemoir &&
                      moment(this.props.singleMemoir?.date_of_birth).format(
                        "DD MMMM YYYY"
                      )}
                  </h5>
                  <div className="mx-4 v-line"></div>
                  <h5 className="m-0 font-weight-bold">
                    {" "}
                    {this.props.singleMemoir &&
                    this.props.singleMemoir.date_of_death
                      ? moment(this.props.singleMemoir.date_of_death).format(
                          "DD MMMM YYYY"
                        )
                      : "Present"}
                  </h5>
                </div>

                <div
                  className={`align-items-center mt-2 justify-content-center ${
                    this.props.singleMemoir &&
                    this.props.singleMemoir.category != "Myself"
                      ? "d-flex"
                      : "d-none"
                  }`}
                >
                  <h5 className="m-0 font-weight-bold">
                    {this.props.singleMemoir &&
                      moment(this.props.singleMemoir.start_date).format(
                        "DD MMMM YYYY"
                      )}
                  </h5>
                  {this.props.singleMemoir &&
                    this.props.singleMemoir.end_date != "" && (
                      <>
                        <div className="mx-4 v-line"></div>
                        <h5 className="m-0 font-weight-bold">
                          {" "}
                          {this.props.singleMemoir &&
                            moment(this.props.singleMemoir.end_date).format(
                              "DD MMMM YYYY"
                            )}
                        </h5>
                      </>
                    )}
                </div>

                <p className="container mt-2">
                  {this.props.singleMemoir &&
                    this.props.singleMemoir.introduction}
                </p>
              </div>

              {this.state.memoirId &&
                this.props.authUser.id &&
                this.getRole(this.state.memoirId, this.props.authUser.id) !=
                  "contributer" && (
                  <div className="mt-2 pb-4 d-flex flex-wrap justify-content-center">
                    {this.props.singleMemoir &&
                    this.props.singleMemoir.isMemoirPublic ? (
                      <>
                        <Link
                          to={`/main/timeline/${this.state.memoirId}`}
                          target={"_blank"}
                        >
                          <Button className="btn-outline mr-3 align-items-center d-flex dashboard-btn"
                          // onClick={this.handleClick}
                          >
                            <span className="mr-2">
                              <svg
                                width="18"
                                height="24"
                                viewBox="0 0 18 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 18.2857C10.2375 18.2857 11.25 17.2571 11.25 16C11.25 14.7429 10.2375 13.7143 9 13.7143C7.7625 13.7143 6.75 14.7429 6.75 16C6.75 17.2571 7.7625 18.2857 9 18.2857ZM15.75 8H14.625V5.71429C14.625 2.56 12.105 0 9 0C5.895 0 3.375 2.56 3.375 5.71429H5.5125C5.5125 3.76 7.07625 2.17143 9 2.17143C10.9237 2.17143 12.4875 3.76 12.4875 5.71429V8H2.25C1.0125 8 0 9.02857 0 10.2857V21.7143C0 22.9714 1.0125 24 2.25 24H15.75C16.9875 24 18 22.9714 18 21.7143V10.2857C18 9.02857 16.9875 8 15.75 8ZM15.75 21.7143H2.25V10.2857H15.75V21.7143Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                            Preview Public View
                          </Button>
                        </Link>
                        <Button
                          className="btn-outline mr-3 dashboard-btn"
                          onClick={() => {
                            this.props.changeMemoirViewStatus(
                              this.state.memoirId,
                              false
                            );
                            this.setState({memoirData:{
                              isMemoirPublic:false
                            }})
                          }}
                        >
                          <span className="mr-2">
                            <svg
                              width="18"
                              height="24"
                              viewBox="0 0 18 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.75 8H14.625V5.71429C14.625 2.56 12.105 0 9 0C5.895 0 3.375 2.56 3.375 5.71429V8H2.25C1.0125 8 0 9.02857 0 10.2857V21.7143C0 22.9714 1.0125 24 2.25 24H15.75C16.9875 24 18 22.9714 18 21.7143V10.2857C18 9.02857 16.9875 8 15.75 8ZM9 18.2857C7.7625 18.2857 6.75 17.2571 6.75 16C6.75 14.7429 7.7625 13.7143 9 13.7143C10.2375 13.7143 11.25 14.7429 11.25 16C11.25 17.2571 10.2375 18.2857 9 18.2857ZM12.4875 8H5.5125V5.71429C5.5125 3.76 7.07625 2.17143 9 2.17143C10.9237 2.17143 12.4875 3.76 12.4875 5.71429V8Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Private Timeline
                        </Button>
                      </>
                    ) : (
                      <Button
                        className="btn-outline mr-3 dashboard-btn"
                        onClick={() => {
                          this.props.changeMemoirViewStatus(
                            this.state.memoirId,
                           true
                          );
                          this.setState({memoirData:{
                            isMemoirPublic:true
                          }})
                        }}
                      >
                        <span className="mr-2">
                          <svg
                            width="18"
                            height="24"
                            viewBox="0 0 18 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 18.2857C10.2375 18.2857 11.25 17.2571 11.25 16C11.25 14.7429 10.2375 13.7143 9 13.7143C7.7625 13.7143 6.75 14.7429 6.75 16C6.75 17.2571 7.7625 18.2857 9 18.2857ZM15.75 8H14.625V5.71429C14.625 2.56 12.105 0 9 0C5.895 0 3.375 2.56 3.375 5.71429H5.5125C5.5125 3.76 7.07625 2.17143 9 2.17143C10.9237 2.17143 12.4875 3.76 12.4875 5.71429V8H2.25C1.0125 8 0 9.02857 0 10.2857V21.7143C0 22.9714 1.0125 24 2.25 24H15.75C16.9875 24 18 22.9714 18 21.7143V10.2857C18 9.02857 16.9875 8 15.75 8ZM15.75 21.7143H2.25V10.2857H15.75V21.7143Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                        Public Timeline
                      </Button>
                    )}
                    <Link
                      to={{
                        pathname: "/dashboard/qrcode",
                        state: {
                          selectedMemoir: this.state.memoirId,
                        },
                      }}
                    >
                      <Button className="btn-outline mr-3 dashboard-btn">
                        <span className="mr-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.5033 19.7915L20.4315 6.28603C20.3647 5.41594 19.6288 4.73433 18.7562 4.73433H16.6392V4.63917C16.6392 2.08111 14.5581 0 12 0C9.44196 0 7.36085 2.08111 7.36085 4.63917V4.73433H5.24388C4.37121 4.73433 3.63532 5.41589 3.56876 6.2842L2.49663 19.7933C2.41366 20.8749 2.7889 21.9518 3.52605 22.7476C4.26321 23.5435 5.30819 24 6.39302 24H17.607C18.6918 24 19.7368 23.5435 20.474 22.7476C21.2111 21.9517 21.5863 20.8749 21.5033 19.7915ZM8.76663 4.63917C8.76663 2.85628 10.2172 1.40578 12 1.40578C13.7829 1.40578 15.2334 2.85633 15.2334 4.63917V4.73433H8.76663V4.63917ZM19.4426 21.7924C18.9636 22.3095 18.3118 22.5942 17.607 22.5942H6.39307C5.68826 22.5942 5.03641 22.3095 4.55744 21.7924C4.07852 21.2753 3.84443 20.6035 3.89824 19.9027L4.97027 6.39352C4.98115 6.25139 5.10133 6.14011 5.24388 6.14011H7.36085V7.87144C7.36085 8.25961 7.67557 8.57433 8.06374 8.57433C8.45191 8.57433 8.76663 8.25961 8.76663 7.87144V6.14011H15.2334V7.87144C15.2334 8.25961 15.5481 8.57433 15.9363 8.57433C16.3245 8.57433 16.6392 8.25961 16.6392 7.87144V6.14011H18.7562C18.8987 6.14011 19.0189 6.25144 19.03 6.39539L20.1018 19.9008C20.1557 20.6035 19.9215 21.2753 19.4426 21.7924Z"
                              fill="black"
                            />
                            <path
                              d="M15.1667 11.9196C14.8923 11.6451 14.4472 11.6451 14.1728 11.9196L11.0342 15.0581L9.82735 13.8513C9.55289 13.5768 9.10782 13.5768 8.83332 13.8513C8.55882 14.1258 8.55882 14.5708 8.83332 14.8453L10.5372 16.5492C10.6744 16.6864 10.8543 16.7551 11.0341 16.7551C11.214 16.7551 11.3939 16.6865 11.5311 16.5492L15.1666 12.9136C15.4412 12.6391 15.4412 12.1941 15.1667 11.9196Z"
                              fill="black"
                            />
                          </svg>
                        </span>
                        Order QR Code
                      </Button>
                    </Link>
                    <Button
                      className="btn-outline mr-3 dashboard-btn"
                      onClick={() => {
                        this.toggleModal("collabModal");
                      }}
                    >
                      <span className="mr-2">
                        <svg
                          width="38"
                          height="24"
                          viewBox="0 0 38 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25.9091 10.2857C28.7764 10.2857 31.0736 7.98857 31.0736 5.14286C31.0736 2.29714 28.7764 0 25.9091 0C23.0418 0 20.7273 2.29714 20.7273 5.14286C20.7273 7.98857 23.0418 10.2857 25.9091 10.2857ZM12.0909 10.2857C14.9582 10.2857 17.2555 7.98857 17.2555 5.14286C17.2555 2.29714 14.9582 0 12.0909 0C9.22364 0 6.90909 2.29714 6.90909 5.14286C6.90909 7.98857 9.22364 10.2857 12.0909 10.2857ZM12.0909 13.7143C8.06636 13.7143 0 15.72 0 19.7143V24H24.1818V19.7143C24.1818 15.72 16.1155 13.7143 12.0909 13.7143ZM25.9091 13.7143C25.4082 13.7143 24.8382 13.7486 24.2336 13.8C26.2373 15.24 27.6364 17.1771 27.6364 19.7143V24H38V19.7143C38 15.72 29.9336 13.7143 25.9091 13.7143Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      Invite Collaborator
                    </Button>
                  </div>
                )}
            </div>
            <div className="downloaded_media mt-4">
              <div className="d-block d-md-flex align-items-center">
                <h3 className="font-weight-bold">Downloaded Media</h3>
                <div className="ml-auto d-block d-md-flex align-items-end"></div>
              </div>
              <div className="mt-4 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <span className="ml-2 font-weight-bold">My Media</span>
                </div>
                <Button
                  className="btn-outline ml-auto px-3 dashboard-btn"
                  style={{ minWidth: "auto" }}
                  onClick={(e) => this.toggleModal("addMedia")}
                >
                  + Add to Your Memoir
                </Button>
              </div>
              <MemoirMedia memoir_id={this.state.memoirId} isEditable={true} />
            </div>
          </div>
          {/* <Input
						type='file'
						onChange={e =>
							this.setState({
								testFile: URL.createObjectURL(
									e.target.files[0]
								),
							})
						}
					/> */}
        </div>
        {/* Image Crop Modal */}
        <Modal isOpen={this.state.displayImage}>
          <ModalBody>
            <h2>Crop Display image</h2>
            <div
              style={{
                position: "relative",
                top: "0",
                width: "100%",
                height: "60vh",
                paddingLeft: "10%",
              }}
            >
              <Cropper
                image={this.state.displayImage}
                crop={this.state.crop}
                zoom={this.state.zoom}
                aspect={this.state.aspect}
                onCropChange={this.onCropChange}
                onCropComplete={this.onCropComplete}
                onZoomChange={this.onZoomChange}
                style={{ width: "100%" }}
              />
            </div>
            <div className="text-right mt-3">
              <Button
                className="mr-2"
                color="danger"
                disabled={this.props.loading}
                onClick={() => {
                  this.setState({
                    displayImage: "",
                  });
                }}
              >
                Close
              </Button>
              <Button
                color="primary"
                onClick={this.saveImage}
                disabled={this.props.loading}
              >
                {this.props.loading ? <Spinner size="sm" /> : "Save Image"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.coverImage}>
          <ModalBody>
            <h2>Crop Cover image</h2>
            <div
              style={{
                position: "relative",
                top: "0",
                width: "100%",
                height: "60vh",
                paddingLeft: "10%",
              }}
            >
              <Cropper
                image={this.state.coverImage}
                crop={this.state.crop}
                zoom={this.state.zoom}
                aspect={this.state.aspect}
                onCropChange={this.onCropChange}
                onCropComplete={this.onCropComplete}
                onZoomChange={this.onZoomChange}
                style={{ width: "100%" }}
              />
            </div>
            <div className="text-right mt-3">
              <Button
                className="mr-2"
                color="danger"
                disabled={this.props.coverLoading}
                onClick={() => {
                  this.setState({
                    coverImage: "",
                  });
                }}
              >
                Close
              </Button>
              <Button
                color="primary"
                onClick={this.saveCropImage}
                disabled={this.props.coverLoading}
              >
                {this.props.coverLoading ? <Spinner size="sm" /> : "Save Image"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
        {/* Modals - Ok */}
        <Modal
          isOpen={this.state.modals.categories}
          size="xl"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("categories")}
        >
          <ModalBody>
            <div className="d-flex">
              <div
                className="ml-auto pointer"
                onClick={(e) => this.toggleModal("categories")}
              >
                <i className="fa fa-times"></i>
              </div>
            </div>
            <div className="modal-content-wrapper pt-0">
              <h4 className="text-center mt-3 font-weight-bold">
                Choose from the categories Below
              </h4>
              <Row className="justify-content-center">
                <Col md="10" xl="8">
                  <div className="row">
                    {this.state.categories.map((category, idx) => (
                      <div className="col-md-6 col-lg-4 col-xl-4 mt-5 text-center">
                        <div
                          className={`category-card ${
                            this.state.selectedCategory == category.name
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) =>
                            this.setState({
                              selectedCategory: category.name,
                            })
                          }
                        >
                          <div className="card-body text-center d-flex flex-column">
                            <img
                              src={category.image}
                              style={{
                                height: 70,
                                margin: "0 auto",
                              }}
                            />
                            <span className="mt-3">{category.name}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              <button
                className="btn btn-outline d-block mx-auto mt-3 position-relative dashboard-btn"
                style={{ fontSize: 32, minHeight: 60 }}
                onClick={(e) => {
                  e.preventDefault();
                  this.toggleModal("createTimeline");
                }}
              >
                Creating a Memoir
              </button>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modals.createTimeline}
          size="lg"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("createTimeline")}
        >
          <ModalBody>
            <div className="d-flex">
              <div
                className="ml-auto pointer"
                onClick={(e) => this.toggleModal("createTimeline")}
              >
                <i className="fa fa-times"></i>
              </div>
            </div>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                let uid = this.props.authUser.id;
                let obj = { ...this.state.memoirData };
                if (this.state.profileType == "person") {
                  obj["category"] = this.state.selectedCategory;
                }
                this.props.createMemoir(uid, obj);
                this.setState();
                this.toggleModal("createTimeline");
              }}
            >
              <div className="modal-content-wrapper pt-0">
                <h5 className="mt-3 font-weight-bold text-center">
                  Create a Memoir
                </h5>
                <span className="d-block timeline-for mt-4">
                  <h6>What is the Memoir for?</h6>
                  <div className="d-flex radio-group">
                    <div className="d-flex radio align-items-center">
                      <input
                        type="radio"
                        name="profileType"
                        onClick={async (e) => {
                          await this.setState({
                            profileType: "person",
                          });
                          this.resetMemoirState();
                        }}
                        checked={this.state.profileType == "person"}
                        id="person"
                      />
                      <label className="ml-2 mt-2" for="person">
                        A Person
                      </label>
                    </div>
                    <div className="ml-5 d-flex radio align-items-center">
                      <input
                        type="radio"
                        name="profileType"
                        onClick={async (e) => {
                          await this.setState({
                            profileType: "else",
                          });
                          this.resetMemoirState();
                        }}
                        checked={this.state.profileType == "else"}
                        id="else"
                      />
                      <label className="ml-2 mt-2" for="else">
                        Something else
                      </label>
                    </div>
                  </div>
                </span>
                <div
                  className={`${
                    this.state.profileType == "person" ? "d-block" : "d-none"
                  }`}
                >
                  <div className="row mt-3">
                    <div className="col-md-2">
                      <label className="m-0">Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Mr"
                        value={this.state.memoirData.title}
                        onChange={(e) =>
                          this.handleMemoirFieldChange("title", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-md-5">
                      <label className="m-0">First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="First name"
                        value={this.state.memoirData.first_name}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "first_name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-5">
                      <label className="m-0">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Last name"
                        value={this.state.memoirData.last_name}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "last_name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>

                  <label className="d-flex mt-3 m-0">Add an introduction</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="This Timeline was created to help collect our memories in a single place online"
                    value={this.state.memoirData.introduction}
                    onChange={(e) =>
                      this.handleMemoirFieldChange(
                        "introduction",
                        e.target.value
                      )
                    }
                  />
                  <h5 className="d-flex mt-5 mb-4">
                    What's your relationship to them?
                  </h5>
                  <select
                    className="form-control"
                    value={this.state.memoirData.relationship}
                    onChange={(e) =>
                      this.handleMemoirFieldChange(
                        "relationship",
                        e.target.value
                      )
                    }
                  >
                    <option selected hidden>
                      Select (Optional)
                    </option>
                  </select>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label className="d-flex m-0">
                        Date of Birth (optional)
                      </label>
                      <input
                        type="date"
                        value={this.state.memoirData.date_of_birth}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "date_of_birth",
                            e.target.value
                          )
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-6 ">
                      <label className="d-flex m-0">
                        Date of Death (optional)
                      </label>
                      <span className="d-block mt-3">
                        - Present <i className="ml-2 fa fa-pencil"></i>
                      </span>
                    </div>
                  </div>
                  <label className="d-flex mt-3 m-0">
                    What's their hometown?
                  </label>
                  <Row>
                    <Col md="8">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="City"
                        value={this.state.memoirData.home_town}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "home_town",
                            e.target.value
                          )
                        }
                      ></input>
                    </Col>
                  </Row>
                </div>
                <div
                  className={`${
                    this.state.profileType == "else" ? "d-block" : "d-none"
                  }`}
                >
                  <Row>
                    <Col md="8">
                      <label className="d-flex mt-3">Choose a Catrgory</label>
                      <select
                        className="form-control"
                        value={this.state.memoirData.else_category}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "else_category",
                            e.target.value
                          )
                        }
                      >
                        <option selected hidden>
                          Pet
                        </option>
                      </select>
                      <label className="d-flex mt-3">Category selected</label>
                      <input
                        className="form-control"
                        placeholder="Category selected"
                      />
                    </Col>
                  </Row>
                  <label className="d-flex mt-3">Add an introduction</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="This Timeline was created to help collect our memories in a single place online"
                    value={this.state.memoirData.introduction}
                    onChange={(e) =>
                      this.handleMemoirFieldChange(
                        "introduction",
                        e.target.value
                      )
                    }
                  />
                  <div className="row mt-3">
                    <div className="col-md-8">
                      <label>Start date</label>
                      <div className="row">
                        <div className="col">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="yyyy"
                            value={this.state.memoirData.start_date_yyyy}
                            onChange={(e) =>
                              this.handleMemoirFieldChange(
                                "start_date_yyyy",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="mm"
                            value={this.state.memoirData.start_date_mm}
                            onChange={(e) =>
                              this.handleMemoirFieldChange(
                                "start_date_mm",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="dd"
                            value={this.state.memoirData.start_date_dd}
                            onChange={(e) =>
                              this.handleMemoirFieldChange(
                                "start_date_dd",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-8">
                      <label>End date</label>
                      <div className="row">
                        <div className="col">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="yyyy"
                            value={this.state.memoirData.end_date_yyyy}
                            onChange={(e) =>
                              this.handleMemoirFieldChange(
                                "end_date_yyyy",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="mm"
                            value={this.state.memoirData.end_date_mm}
                            onChange={(e) =>
                              this.handleMemoirFieldChange(
                                "end_date_mm",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="dd"
                            value={this.state.memoirData.end_date_dd}
                            onChange={(e) =>
                              this.handleMemoirFieldChange(
                                "end_date_dd",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <Row>
                    <Col md="8">
                      <label className="d-flex mt-3">Add a Location</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="City"
                        value={this.state.memoirData.location}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "location",
                            e.target.value
                          )
                        }
                      ></input>
                    </Col>
                  </Row>
                </div>

                <h5 className="d-flex mt-5">Memoir Privacy Settings</h5>
                <div className="d-flex">
                  <p className="mt-0">
                    Your privacy is extremely important to us. You can
                    <br />
                    change these settings at anytime
                  </p>
                </div>
                <div className="settings">
                  <div className="d-flex align-items-center">
                    <span>
                      <CustomToggler
                        value={this.state.memoirData.isMemoirPublic}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "isMemoirPublic",
                            e.target.value
                          )
                        }
                      />
                    </span>
                    <p className="font-weight-bold ml-4">Memoir is public</p>
                  </div>
                  <div className="d-flex align-items-center">
                    <span>
                      <CustomToggler
                        value={this.state.memoirData.isHomeTownPublic}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "isHomeTownPublic",
                            e.target.value
                          )
                        }
                      />
                    </span>
                    <p className="font-weight-bold ml-4">Hometown is public</p>
                  </div>
                  <div className="d-flex align-items-center">
                    <span>
                      <CustomToggler
                        value={this.state.memoirData.isDOBPublic}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "isDOBPublic",
                            e.target.value
                          )
                        }
                      />
                    </span>
                    <p className="font-weight-bold ml-4">DOB is public</p>
                  </div>
                  {/* <div className='d-flex align-items-center'>
										<span>
											<CustomToggler
												value={
													this.state.memoirData
														.isHideFromSearchEngines
												}
												onChange={e =>
													this.handleMemoirFieldChange(
														'isHideFromSearchEngines',
														e.target.value
													)
												}
											/>
										</span>
										<p className='font-weight-bold ml-4'>
											Hide from search engines
										</p>
									</div> */}
                  <div className="d-flex align-items-center">
                    <span>
                      <CustomToggler
                        value={this.state.memoirData.isIntroductionVisible}
                        onChange={(e) =>
                          this.handleMemoirFieldChange(
                            "isIntroductionVisible",
                            e.target.value
                          )
                        }
                      />
                    </span>
                    <p className="font-weight-bold ml-4">
                      Allow memoir introduction to be visible
                    </p>
                  </div>
                </div>
                <div className="d-flex mt-3 justify-content-center">
                  <button
                    className="btn btn-outline w-100 mr-2 dashboard-btn"
                    style={{
                      border: "1.5px solid #566edc",
                      color: "#566edc",
                    }}
                  >
                    Create a Memoir
                  </button>
                  <button
                    className="btn btn-outline w-100 dashboard-btn"
                    onClick={(e) => this.toggleModal("createTimeline")}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Form>
          </ModalBody>
        </Modal>
        <Modal
          // isOpen={this.state.modals.addMedia}
          size="lg"
          centered
          className="custom-modal"
          toggle={(e) => this.toggleModal("addMedia")}
        >
          <ModalBody>
            <div>
              <div className="d-flex">
                <div className="ml-auto pointer">
                  <i
                    className="fa fa-times"
                    onClick={(e) => this.toggleModal("addMedia")}
                  ></i>
                </div>
              </div>
              <h5 className="font-weight-bold text-center">Add Media</h5>
              <div className="row mt-5">
                <div className="col-md-8">
                  <label className="m-0">Start date</label>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="yyyy"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="mm"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="dd"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-10">
                  <label className="m-0">Heading</label>
                  <div className="row">
                    <div className="col-10">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="yyyy"
                      />
                    </div>
                    <div className="col-2">
                      <button
                        className="text-uppercase d-block w-100"
                        style={{
                          fontSize: 14,
                          background: "#484E9C",
                          border: 0,
                          color: "#fff",
                          borderRadius: "8px",
                          height: "100%",
                        }}
                      >
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="darg-drop mt-4" style={{ height: 200 }}>
                <div>
                  <i className="fa fa-plus d-block text-center text-muted"></i>
                  <p>
                    <span className="text-muted">Add Photo/Videos </span>
                    or drop file here
                  </p>
                </div>
              </div> */}

              <label className="mt-3">Add a description</label>
              <textarea rows={5} className="form-control" />
              <div className="d-flex mt-4 justify-content-end">
                <button className="btn btn-outline f14 mr-3">+ Add More</button>
                <button
                  className="btn btn-outline f14 dashboard-btn"
                  onClick={(e) => this.toggleModal("addMedia")}
                >
                  Cancel
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        {/* Invite Collaborator modal */}

        <Modal
          isOpen={this.state.modals.collabModal}
          size="xl"
          centered
          className="custom-modal"
          toggle={(e) => {
            this.toggleModal("collabModal");
          }}
        >
          <ModalBody>
            <div className="modal-content-wrapper ">
              <div className="d-flex">
                <span
                  className="ml-auto pointer"
                  onClick={(e) => this.toggleModal("collabModal")}
                >
                  <i className="fa fa-times"></i>
                </span>
              </div>
              <h5 className="mt-3 text-center font-weight-bold">
                Inviting contributors to add memories
              </h5>
              <div className="d-flex mt-3">
                {/* <
                className='custom-close-icon ml-auto'
                onClick={e =>
                  this.toggleModal('inviteMember')
                }
              >
                <i className='fa fa-times'></i>
              </> */}
              </div>
              <div className="d-flex">
                <div className="position-relative w-100">
                  <input
                    type="text"
                    className="form-control padding-left-45"
                    placeholder="Search by Email..."
                    value={this.state.emailSearch}
                    onChange={(e) =>
                      this.setState({
                        emailSearch: e.target.value,
                      })
                    }
                  ></input>
                  <span>
                    <i
                      className="fa fa-search position-absolute"
                      style={{
                        top: "50%",
                        left: 15,
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                  </span>
                </div>
                <button
                  className="btn-outline dashboard-btn"
                  disabled={!this.state.emailSearch}
                  onClick={() => {
                    this.props.fetchByEmail(this.state.emailSearch);
                  }}
                >
                  Search
                </button>
              </div>

              {this.props.emailUser.length > 0 && (
                <div className="d-flex align-items-center mt-3">
                  <div
                    className=""
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      background: "#ccc",
                    }}
                  ></div>
                  <div className="ml-2">
                    <h6 className="f-14">
                      {this.props.emailUser[0].firstname != undefined &&
                        this.props.emailUser[0].firstname}{" "}
                      {this.props.emailUser[0].lastname != undefined &&
                        this.props.emailUser[0].lastname}
                    </h6>
                    <h6 className="text-muted f-14">
                      {this.props.emailUser[0].email != undefined &&
                        this.props.emailUser[0].email}
                    </h6>
                  </div>
                </div>
              )}

              {/* <Row className="mt-4">
                <Col md="3">
                  <Label className="m-0">Selected Date</Label>
                  <Input type="date"></Input>
                </Col>
                <Col md="4">
                  <Label className="m-0">Selected Milestone</Label>
                  <Input type="select"></Input>
                </Col>
              </Row>
              <Row className="mt-4" noGutters>
                {Object.keys(this.props.singleMemoir).length > 0 && (
                  <Col xl="4" lg="6">
                    <LC_Media memoir={this.props.singleMemoir} />
                  </Col>
                )}
              </Row> */}

              <div className="access-level mt-5">
                <label>Select their access level</label>
                <div className="d-flex radio-group">
                  <div className="d-flex radio align-items-center">
                    <input
                      type="radio"
                      name="role"
                      value="admin"
                      onChange={(e) =>
                        this.setState({
                          role: e.target.value,
                        })
                      }
                    />
                    <span className="ml-2">Admin</span>
                  </div>
                  <div className="ml-5 d-flex radio align-items-center">
                    <input
                      type="radio"
                      name="role"
                      value="contributer"
                      onChange={(e) =>
                        this.setState({
                          role: e.target.value,
                        })
                      }
                    />
                    <span className="ml-2">Contributer</span>
                  </div>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6">
                      <button
                        className="btn btn-outline d-block w-100 dashboard-btn"
                        onClick={async (e) => {
                          e.preventDefault();

                          if (
                            this.props.emailUser &&
                            this.props.emailUser.length > 0 &&
                            this.props.emailUser[0].id
                          ) {
                            let obj = {
                              id:
                                this.props.emailUser &&
                                this.props.emailUser[0].id,
                              role: this.state.role,
                            };
                            if (
                              this.props.singleMemoir.id == "" ||
                              this.state.role == "" ||
                              obj.id == ""
                            ) {
                              // toast.warning(
                              // 	'Please Select All fields'
                              // );
                              this.props.customAlert(
                                true,
                                "Please Select All fields"
                              );

                              setTimeout(() => {
                                this.props.customAlert(false, "");
                              }, 1500);
                            } else {
                              if (
                                this.getMemoirDetails(
                                  this.props.singleMemoir.id
                                ).user_id == this.props.emailUser[0].id
                              ) {
                                this.props.customAlert(
                                  true,
                                  "Selected user is the creator of this memoir!"
                                );

                                setTimeout(() => {
                                  this.props.customAlert(false, "");
                                }, 1500);
                                // toast.warning(
                                // 	'Selected user is the creator of this memoir!'
                                // );
                              } else {
                                this.props.updateMemoirCollab(
                                  this.props.singleMemoir.id,
                                  obj,
                                  this.props.authUser.id
                                );

                                this.toggleModal("collabModal");
                              }
                            }
                          } else {
                            this.props.customAlert(true, "Please Select User");

                            setTimeout(() => {
                              this.props.customAlert(false, "");
                            }, 1500);
                            // toast.warning(
                            // 	'Please Select User'
                            // );
                          }
                        }}
                        disabled={this.props.collabLoading}
                      >
                        {this.props.collabLoading ? (
                          <Spinner size="sm" />
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                    <div className="col-md-6 mt-3 mt-md-0">
                      <button
                        className="btn btn-outline d-block w-100 dashboard-btn"
                        onClick={(e) => {
                          this.toggleModal("collabModal");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    authUser: state.authUser,
    singleMemoir: state.memoir.singleMemoir,
    singleMedia: state.memoir.singleMedia,
    loading: state.memoir.loading,
    coverLoading: state.memoir.coverLoading,
    emailUser: state.collaborative.emailUser,
    collabLoading: state.collaborative.loading,
    memoirs: state.memoir.memoirs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createMemoir: (uid, obj) => dispatch(createMemoir(uid, obj)),
    displayImageUpdate: (obj, id, u_id, onSuccess) =>
      dispatch(displayImageUpdate(obj, id, u_id, onSuccess)),
    coverImageUpdate: (obj, id, u_id, func) =>
      dispatch(coverImageUpdate(obj, id, u_id, func)),
    getSingleMemoir: (id) => dispatch(getSingleMemoir(id)),
    getSingleMedia: (id) => dispatch(getSingleMedia(id)),
    changeMemoirViewStatus: (id, value) =>
      dispatch(changeMemoirViewStatus(id, value)),
    fetchByEmail: (email) => dispatch(fetchByEmail(email)),
    updateMemoirCollab: (id, obj, u_id) =>
      dispatch(updateMemoirCollab(id, obj, u_id)),
    customAlert: (val, message) => dispatch(customAlert(val, message)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);
